


































































import { Component, Vue } from "vue-property-decorator";
import AdminsApi from "@/services/AdminsApi";
import UsersApi from "@/services/UsersApi";
import organizationAdminsApi from "@/services/OrganizationAdmins";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import AuthModule from "@/store/auth";
import OrganizationUserApi from "@/services/OrganizationUsers";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class FormEmailEdit extends Vue {
  // メールアドレスフォーム
  private email = "";

  // 確認メールアドレスフォーム
  private cfmEmail = "";

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private async mounted() {
    this.fetch();
  }

  // アカウント情報の取得
  private fetch() {
    if (this.me?.email) {
      // formに現在のアドレスの表示
      this.email = this.me.email;
    }
  }

  // 送信が押されたとき
  private async submit() {
    if (!this.me) {
      return;
    }
    try {
      if (this.$route.name === "MRegisterEmailEdit") {
        // adminEmailを実行
        await this.adminEmail(this.me.uuid, this.email);
      } else if (this.$route.name === "URegisterEmailEdit") {
        if (this.me.roleId === 2) {
          await this.userEmail(this.me.uuid, this.email);
        } else {
          await this.organizationUserEmail(this.me.uuid, this.email);
        }
      } else {
        await this.organizationAdminEmail(this.me.uuid, this.email);
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  private async userEmail(uuid: string, Email: string) {
    // 更新するuuid,form(form内に入力されたもの)の取得
    await UsersApi.instance.updateUserByUuid(uuid, { email: Email });
    // URegisterEmailEditCompに進む
    this.$router.push({ name: "URegisterEmailEditComp" });
  }

  private async adminEmail(uuid: string, Email: string) {
    // 更新するuuid,form(form内に入力されたもの)の取得
    await AdminsApi.instance.updateAdminByUuid(uuid, { email: Email });
    // MRegisterEmailEditCompに進む
    this.$router.push({ name: "MRegisterEmailEditComp" });
  }

  private async organizationUserEmail(uuid: string, Email: string) {
    // 更新するuuid,form(form内に入力されたもの)の取得
    await OrganizationUserApi.instance.updateOrganizationUserByUuid(uuid, { email: Email });
    // URegisterEmailEditCompに進む
    this.$router.push({ name: "URegisterEmailEditComp" });
  }

  private async organizationAdminEmail(uuid: string, Email: string) {
    // 更新するuuid,form(form内に入力されたもの)の取得
    await organizationAdminsApi.instance.updateOrganizationAdminByUuid(uuid, { email: Email });
    // ORegisterEmailEditCompに進む
    this.$router.push({ name: "ORegisterEmailEditComp" });
  }
}
